import { ReactNode } from "react";
import { atom } from "recoil";

export type ApplicationModalStore = {
  modalState: "open" | "close";
  component: ReactNode | null;
  onClose?: () => void | Promise<void>;
};

export const applicationModalStore = atom<ApplicationModalStore>({
  key: "applicationModal",
  default: {
    modalState: "close",
    component: null,
  },
});
